/* eslint-disable react/react-in-jsx-scope */
import { Column } from "./styled";
import Cell from "./components/Structure/components/Cell";
import { TITLES, ACCESSORS, WIDTH, ID } from "./constants";
import MainColumn from "./components/Structure/components/MainColumn";
import ArticleCell from "./components/Structure/components/ArticleCell";
import Urgent from "./components/Structure/components/Urgent";
import { getAccessor } from "../../../../../store/Concept/functions";
import SubTotal from "./components/Structure/components/SubTotal";
import FiscalValue from "./components/Structure/components/FiscalValue";
import LotAmount from "./components/Structure/components/LotAmount";
import Amount from "./components/Structure/components/Amount";

export const getColumns = (addItem, handleChange) => {
  return [
    {
      Header: () => null,
      id: ID,
      columns: [
        {
          Header: () => <MainColumn />,
          id: "articleDescription",
          accessor: (row) => getAccessor(row),
          Cell: ({ value, row }) => <ArticleCell row={row} value={value} addItem={addItem} />,
          width: WIDTH,
        },
        {
          Header: () => <Column>{TITLES[2]}</Column>,
          accessor: ACCESSORS[1],
          Cell: ({ value, row }) => <Cell value={"$ " + value} row={row} />,
        },
        {
          Header: () => <Column>{TITLES[3]}</Column>,
          accessor: ACCESSORS[2],
          Cell: ({ value, row }) => <Amount handleChange={handleChange} row={row} name={ACCESSORS[2]} defVal={value} />,
        },
        {
          Header: () => <Column>{TITLES[4]}</Column>,
          accessor: ACCESSORS[3],
          Cell: ({ value, row }) => (
            <FiscalValue handleChange={handleChange} row={row} name={ACCESSORS[3]} defVal={value} />
          ),
        },
        {
          Header: () => <Column>{TITLES[5]}</Column>,
          accessor: ACCESSORS[4],
          Cell: ({ value, row }) => <Cell value={value + "%"} row={row} />,
        },
        {
          Header: () => <Column>{TITLES[6]}</Column>,
          accessor: ACCESSORS[5],
          Cell: ({ value, row }) => (
            <LotAmount handleChange={handleChange} row={row} name={ACCESSORS[5]} defVal={value} />
          ),
        },
        {
          Header: () => <Column>{TITLES[7]}</Column>,
          accessor: ACCESSORS[6],
          Cell: ({ row }) => <Urgent row={row} />,
        },
        {
          Header: () => <Column>{TITLES[8]}</Column>,
          accessor: ACCESSORS[7],
          Cell: ({ row }) => <SubTotal row={row} />,
        },
      ],
    },
  ];
};
